<template>
 <v-layout row justify-center>
    <v-dialog :value="active" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>SELECT ATTACHMENT</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeModal()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="text-xs-left mt-5 vh90">
          <unoapp-resource-picker @resources-selected="resourceSelected" :apiToken="token"></unoapp-resource-picker>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import UnoappResourcePicker from '@/plugins/unoapp-resource-picker/app.resource.picker';
import { mapActions, mapGetters } from 'vuex';
import store from '@/store/store';

export default {
  data() {
    return {
    }
  },
  components: {
    UnoappResourcePicker,
  },
  props: {
    resourceSelected: { type: Function },
  },
  computed: {
    token() {
      return this.$store.getters.getLoggedInUserToken;
    }, 
    ...mapGetters('attachment', [
      'active',
    ]),
  },

  methods: {
   
    closeModal() {
      this.setAttachmentPopup(false);
    },
    ...mapActions({
      setAttachmentPopup: 'attachment/setActive',
    }),
  },
};
</script>
<style>
.vh90{
  max-height: 78VH;
  overflow-y: scroll;
}
</style>
